WiseMetering.Views.ShowWeatherAPIIntegration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integrations/weather_api/show',
    title: () => i18next.t('modal.title.integrations.show'),

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            site: this.model.site(),
            integrationIndicators: this.model.integrationIndicators()
        };
    }
});
